export enum MessageType {
    text = 'text',
    link = 'link',
    userMention = 'userMention',
    jumpLink = 'jumpLink',
}

export interface IBaseMessage {
    type: MessageType;
    text: string;
    id: number;
}

export type IMessage = IUserMentionMessage | ILinkMessage | ITextMessage;

export type ITextMessage = IBaseMessage;

export interface ILinkMessage extends IBaseMessage {
    link?: string;
}

export interface IUserMentionMessage extends IBaseMessage {
    userId?: string;
}

export interface IJumpLinkMessage extends IBaseMessage {
    link?: string;
}
